import React from 'react';
import { Helmet } from 'react-helmet';
import { useUnit } from 'effector-react';
import { useT } from 'src/i18n';
import { $locale } from 'src/models/locale';

export const BASE_URL = 'https://1-2dev.ru';

const PAGE_PATHS = {
  home: { ru: '/', en: '/en' },
  projects: { ru: '/projects', en: '/en/projects' },
};

const buildPersonJsonLd = (t) => ({
  '@context': 'https://schema.org',
  '@type': 'Person',
  name: 'Mikhail Rubtsov',
  alternateName: 'Рубцов Михаил',
  jobTitle: 'Software Developer',
  url: BASE_URL,
  image: `${BASE_URL}/images/og.png`,
  sameAs: [t.contacts.telegramUrl],
  email: `mailto:${t.contacts.email}`,
  telephone: '+7-939-7000-772',
  knowsAbout: [
    'Python', 'JavaScript', 'PHP', 'C/C++',
    'Web Development', 'Bots', 'Parsers', 'Microservices',
    'Ethereum Smart Contracts',
  ],
});

export const Seo = ({ page }) => {
  const t = useT();
  const locale = useUnit($locale);
  const meta = t.seo[page];

  const ruUrl = `${BASE_URL}${PAGE_PATHS[page].ru}`;
  const enUrl = `${BASE_URL}${PAGE_PATHS[page].en}`;
  const canonical = locale === 'en' ? enUrl : ruUrl;

  return (
    <Helmet htmlAttributes={{ lang: locale }}>
      <title>{meta.title}</title>
      <meta name="description" content={meta.description} />

      <link rel="canonical" href={canonical} />
      <link rel="alternate" hreflang="ru" href={ruUrl} />
      <link rel="alternate" hreflang="en" href={enUrl} />
      <link rel="alternate" hreflang="x-default" href={ruUrl} />

      <meta property="og:title" content={meta.title} />
      <meta property="og:description" content={meta.description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={t.seo.siteName} />
      <meta property="og:locale" content={t.seo.ogLocale} />
      <meta property="og:image" content={`${BASE_URL}/images/og.png`} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />

      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={meta.title} />
      <meta name="twitter:description" content={meta.description} />
      <meta name="twitter:image" content={`${BASE_URL}/images/og.png`} />

      {page === 'home' && (
        <script type="application/ld+json">
          {JSON.stringify(buildPersonJsonLd(t))}
        </script>
      )}
    </Helmet>
  );
};
